// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  --btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  --btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
  --dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;
}

.fixed_button {
  width: 12em;
  height: 1.5em;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: #567db8;
  border: 0;
  border-radius: 2px;
  transform: translate(0, 0);
  box-shadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  cursor: pointer;
}
.fixed_button.autoW {
  width: auto;
}
.fixed_button__container {
  z-index: 200;
  right: 0;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 10px;
}
.fixed_button__blue {
  background: #dae1ec;
}
.fixed_button__blue:disabled {
  background: rgba(218, 225, 236, 0.5411764706);
  cursor: default;
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button__blue:disabled:hover {
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button__transparent {
  background: #f5f5f5;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
}
.fixed_button__transparent:disabled {
  background: #f5f5f5;
  cursor: default;
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button__transparent:hover {
  background: #dae1ec;
}
.fixed_button__red {
  background-color: #f3cfcc;
}
.fixed_button__accent {
  background-color: #dae1ec;
}
.fixed_button__accent div {
  color: #b72025;
}
.fixed_button__orange {
  background-color: #ffa945;
}
.fixed_button__delete {
  margin-left: 10px;
  background: #f3cfcc;
}
.fixed_button__delete:disabled {
  background: #f1dedc;
  cursor: default;
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button__delete:disabled:hover {
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button__red {
  background: #f3cfcc;
}
.fixed_button__red:disabled {
  background: #f1dedc;
  cursor: default;
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button__red:disabled:hover {
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button.autoWidth {
  width: max-content;
  word-wrap: normal;
  overflow-wrap: normal;
  word-break: keep-all;
  white-space: nowrap; /* Запретить перенос текста по строчке */
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
}

.btn__upload {
  display: flex;
  align-items: center;
  height: 2em;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.btn__upload label {
  display: flex;
  align-items: center;
}
.btn__upload:disabled {
  cursor: not-allowed;
  opacity: 50%;
}
.btn__upload p {
  display: inline;
  font-style: italic;
  font-weight: 400;
}

.remindBtn--blue svg g path {
  stroke: #426ba6;
  stroke-opacity: 0.7;
}

.remindBtn--green svg g path {
  stroke: #69a042;
}

.remindBtn--yellow svg g path {
  stroke: #ffa31a;
}

.remindBtn--red svg g path {
  stroke: #b72025;
}

.remindBtn--grey svg g path {
  stroke: #c8c8c8;
}

.remindBtn--transparent svg g path {
  stroke: transparent;
}

.close_btn {
  position: absolute;
  top: 0;
  right: 0;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background-color: aliceblue;
  font-size: 20px;
  line-height: 19px;
  font-weight: 300;
  margin-top: -5px;
  cursor: pointer;
}

.img_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  cursor: pointer;
}
.img_btn img {
  width: 1em;
  height: 1em;
}
.img_btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.img_btn .img_disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.img_btn.definedFilters {
  background-color: #dae1ec;
  border-radius: 50%;
  width: 3em;
  height: 3em;
  box-shadow: rgba(0, 0, 0, 0.2) 0 3px 5px -1px, rgba(0, 0, 0, 0.14) 0 6px 10px 0, rgba(0, 0, 0, 0.12) 0 1px 18px 0;
}
.iconBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  width: 22px;
  height: 22px;
  padding: 0;
  opacity: 1;
  transition: opacity 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}
.iconBtn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.filter-icon-btn {
  background-color: transparent;
  border-radius: 50%;
  width: 3em;
  height: 3em;
  box-shadow: transparent 0 3px 5px -1px, transparent 0 6px 10px 0, transparent 0 1px 18px 0;
  transition: box-shadow 0.3s cubic-bezier(0.22, 1, 0.36, 1), background-color 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}
.filter-icon-btn.definedFilters {
  background-color: #dae1ec;
  border-radius: 50%;
  width: 3em;
  height: 3em;
  box-shadow: rgba(0, 0, 0, 0.2) 0 3px 5px -1px, rgba(0, 0, 0, 0.14) 0 6px 10px 0, rgba(0, 0, 0, 0.12) 0 1px 18px 0;
}

.little-icon-btn {
  width: 12px;
  height: 12px;
}

.button-add-img {
  position: absolute;
  bottom: -25px;
  right: -5px;
}

.iconBtn-border {
  border: 2px solid #426ba6;
  border-radius: 50%;
  transition: scale 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}
.iconBtn-border:hover {
  scale: 1.5;
}
.iconBtn-border:disabled {
  scale: 1;
}

.link-iconBtn {
  background-color: #dae1ec;
  border-radius: 4px;
  width: 66px;
  height: 28px;
  box-shadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  transition: box-shadow 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}
.link-iconBtn:not(:disabled):hover {
  box-shadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
}

.activeBtn {
  background-color: rgb(218, 225, 236);
  border-radius: 4px;
  width: 40px;
}

.widthBtn {
  width: 40px;
}

.external-iconBtn {
  background-color: #dae1ec;
  border-radius: 4px;
  width: 40px;
  box-shadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  transition: box-shadow 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}
.external-iconBtn:not(:disabled):hover {
  box-shadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
}

.shareBtn {
  position: absolute;
  bottom: 14px;
  right: 5.5%;
  z-index: 500;
}

.button-del-img {
  position: absolute;
  right: -3px;
  top: -3px;
}

.button-main-del-img {
  position: absolute;
  right: -3px;
  top: -3px;
}
@media (min-width: 1600px) {
  .button-main-del-img {
    right: 15px;
  }
}

.logoutBtn {
  width: 14px;
  height: 14px;
}

.filter_btn {
  background: transparent;
  border: 0;
  cursor: pointer;
  position: relative;
  display: inline-block;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
  white-space: nowrap;
  width: 100%;
  font-size: "0.8em";
}

.left_fixed_btn {
  position: absolute;
  left: 1em;
  bottom: 1em;
}

.right_fixed_btn {
  position: absolute;
  right: 1em;
  bottom: 1em;
}

.reestr_btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  background: transparent;
  border: 0;
}
.reestr_btn .label {
  white-space: nowrap;
}
.reestr_btn:disabled {
  cursor: default;
  opacity: 50%;
}

.status-button_info {
  padding: 2px 1.5em;
  border-radius: 3px;
  border: 0.5px solid var(--main-80, #88a5cf);
  background: var(--main-20, #dae1ec);
}
.status-button_info img {
  width: 2em;
}

.status-button {
  width: 80px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background-color: #dae1ec;
  border-radius: 7%;
  cursor: pointer;
}
.status-button:disabled {
  cursor: default;
  opacity: 0.6;
}

.status-circle-external {
  box-sizing: content-box;
  border-radius: 50%;
  border: 1px solid grey;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-circle-internal {
  border-radius: 50%;
  width: 14px;
  height: 14px;
}

.pressed {
  background-color: rgba(123, 130, 140, 0.5411764706);
  box-shadow: rgba(0, 0, 0, 0.2) 0 -3px -5px 1px, rgba(0, 0, 0, 0.14) 0 -6px -10px 0, rgba(0, 0, 0, 0.12) 0 -1px -18px 0;
  border-radius: 5px;
}

.active-action-button {
  background: rgb(218, 225, 236);
}

.btn-responsive {
  transition: box-shadow 0.3s cubic-bezier(0.25, 1, 0.5, 1), transform 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}
.btn-responsive:hover {
  box-shadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
}
.btn-responsive:active {
  transform: scale(0.97);
  box-shadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
}

.reversIconBtn {
  transform: rotate(180deg);
}

.btnSign {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  color: #ffffff;
  border-radius: 50%;
  background-color: #b72025;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}`, "",{"version":3,"sources":["webpack://./src/Styles/Buttons.scss","webpack://./src/Components/App/vars.scss","webpack://./src/Components/App/mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;AC8ChB;EACE,sDAAA;EACA,0DAAA;EACA,2GAAA;EACA,kDAAA;AD5CF;;AAHA;EAEE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,gBAAA;EAEA,cAAA;EACA,SAAA;EACA,kBAAA;EAEA,0BAAA;EACA,sDCgBa;EDdb,eAAA;AACF;AAEE;EACE,WAAA;AAAJ;AAGE;EAKE,YAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,SAAA;AALJ;AASE;EACE,mBAAA;AAPJ;AASI;EACE,6CAAA;EACA,eAAA;EACA,uCAAA;AAPN;AASM;EACE,uCAAA;AAPR;AAaE;EACE,mBAAA;EACA,iDC1DU;AD+Cd;AAYI;EACE,mBAAA;EACA,eAAA;EACA,uCAAA;AAVN;AAaI;EACE,mBAAA;AAXN;AAiBE;EACE,yBAAA;AAfJ;AAiBE;EACE,yBAAA;AAfJ;AAiBI;EACE,cCvEQ;ADwDd;AAmBE;EACE,yBAAA;AAjBJ;AAoBE;EACE,iBAAA;EACA,mBAAA;AAlBJ;AAmBI;EACE,mBAAA;EACA,eAAA;EACA,uCAAA;AAjBN;AAmBM;EACE,uCAAA;AAjBR;AAsBE;EAEE,mBAAA;AArBJ;AAsBI;EACE,mBAAA;EACA,eAAA;EACA,uCAAA;AApBN;AAsBM;EACE,uCAAA;AApBR;AA8BE;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA,EAAA,wCAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AA5BJ;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,SAAA;EACA,uBAAA;EACA,eAAA;AA7BF;AA8BE;EACE,aAAA;EACA,mBAAA;AA5BJ;AA+BE;EACE,mBAAA;EACA,YAAA;AA7BJ;AAgCE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AA9BJ;;AAmCE;EACE,eAAA;EACA,mBAAA;AAhCJ;;AAqCE;EACE,eAAA;AAlCJ;;AAsCE;EACE,eAAA;AAnCJ;;AAuCE;EACE,eAAA;AApCJ;;AAwCE;EACE,eAAA;AArCJ;;AAyCE;EACE,mBAAA;AAtCJ;;AA0CA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,iDAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAvCF;;AA0CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AAvCF;AAwCE;EACE,UAAA;EACA,WAAA;AAtCJ;AAyCE;EACE,YAAA;EACA,mBAAA;AAvCJ;AAyCE;EACE,YAAA;EACA,mBAAA;AAvCJ;AAyCE;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EAGA,iHAAA;AAzCJ;AA8CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,uDAAA;AA5CF;AA6CE;EACE,YAAA;EACA,mBAAA;AA3CJ;;AA+CA;EACE,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EAGA,0FAAA;EACA,gHAAA;AA9CF;AA+CE;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EAGA,iHAAA;AA/CJ;;AAmDA;EACE,WAAA;EACA,YAAA;AAhDF;;AAmDA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AAhDF;;AAsDA;EACE,yBAAA;EACA,kBAAA;EACA,qDAAA;AAnDF;AAoDE;EACE,UAAA;AAlDJ;AAoDE;EACE,QAAA;AAlDJ;;AAsDA;EACE,yBC3SiB;ED4SjB,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sDCnRa;EDoRb,yDAAA;AAnDF;AAoDE;EACE,kGCpRgB;ADkOpB;;AAqDA;EACE,oCCzSe;ED0Sf,kBAAA;EACA,WAAA;AAlDF;;AAqDA;EACE,WAAA;AAlDF;;AAqDA;EACE,yBChUiB;EDiUjB,kBAAA;EACA,WAAA;EAEA,sDCxSa;EDySb,yDAAA;AAnDF;AAoDE;EACE,kGCzSgB;ADuPpB;;AAsDA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAnDF;;AAsDA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAnDF;;AAqDA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAlDF;AElIE;EFiLF;IAMI,WAAA;EAjDF;AACF;;AAmDA;EACE,WAAA;EACA,YAAA;AAhDF;;AAmDA;EACE,uBAAA;EACA,SAAA;EAEA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,iDAAA;EAEA,mBAAA;EACA,WAAA;EACA,kBAAA;AAlDF;;AAsDA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAnDF;;AAqDA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AAlDF;;AAqDA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AAlDF;AAmDE;EACE,mBAAA;AAjDJ;AAoDE;EACE,eAAA;EACA,YAAA;AAlDJ;;AAsDA;EACE,kBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mCAAA;AAnDF;AAqDE;EACE,UAAA;AAnDJ;;AAuDA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AApDF;AAsDE;EACE,eAAA;EACA,YAAA;AApDJ;;AAwDA;EACE,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AArDF;;AAwDA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AArDF;;AAwDA;EACE,mDAAA;EACA,sHAAA;EACA,kBAAA;AArDF;;AAwDA;EACE,8BAAA;AArDF;;AAwDA;EACE,uGAAA;AArDF;AAuDE;EACE,kGC5agB;ADuXpB;AAwDE;EACE,sBAAA;EACA,sDCnbW;AD6Xf;;AA0DA;EACE,yBAAA;AAvDF;;AA0DA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBCpeY;EDqeZ,yCAAA;AAzDF","sourcesContent":["@use \"../Components/App/mixins.scss\" as mx;\n@import \"../Components/App/vars.scss\";\n\n.fixed_button {\n  // border: none;\n  width: 12em;\n  height: 1.5em;\n  box-sizing: border-box;\n  justify-content: center;\n  align-items: center;\n  // padding: 2px 1em;\n  font-weight: 500;\n  // font-size: 13px;\n  color: #567db8;\n  border: 0;\n  border-radius: 2px;\n\n  transform: translate(0, 0);\n  box-shadow: $btnBoxShadow;\n\n  cursor: pointer;\n  // right: 0;\n\n  &.autoW {\n    width: auto;\n  }\n\n  &__container {\n    // width: 335px;\n    // position: relative;\n    // margin-top: -20px;\n    // left: 20px;\n    z-index: 200;\n    right: 0;\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n    gap: 10px;\n    // position: relative;\n  }\n\n  &__blue {\n    background: #dae1ec;\n\n    &:disabled {\n      background: #dae1ec8a;\n      cursor: default;\n      color: #567db869;\n      // background: #3b4c63;\n      &:hover {\n        color: #567db869;\n        // font-weight: 700;\n      }\n    }\n  }\n\n  &__transparent {\n    background: #f5f5f5;\n    border: $border-thin;\n    &:disabled {\n      background: #f5f5f5;\n      cursor: default;\n      color: #567db869;\n      // background: #3b4c63;\n    }\n    &:hover {\n      background: #dae1ec;\n      // color: #567db869;\n      // font-weight: 700;\n    }\n  }\n\n  &__red {\n    background-color: #f3cfcc;\n  }\n  &__accent {\n    background-color: #dae1ec;\n\n    & div {\n      color: $accentColor;\n    }\n  }\n\n  &__orange {\n    background-color: #ffa945;\n  }\n\n  &__delete {\n    margin-left: 10px;\n    background: #f3cfcc;\n    &:disabled {\n      background: #f1dedc;\n      cursor: default;\n      color: #567db869;\n      // background: #3b4c63;\n      &:hover {\n        color: #567db869;\n        // font-weight: 700;\n      }\n    }\n  }\n  &__red {\n    // margin-left: 10px;\n    background: #f3cfcc;\n    &:disabled {\n      background: #f1dedc;\n      cursor: default;\n      color: #567db869;\n      // background: #3b4c63;\n      &:hover {\n        color: #567db869;\n        // font-weight: 700;\n      }\n    }\n  }\n\n  // &:disabled{\n  //     cursor:default;\n  //     opacity: 50%;\n  // }\n  &.autoWidth {\n    width: max-content;\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: keep-all;\n    white-space: nowrap; /* Запретить перенос текста по строчке */\n    display: inline-block;\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n}\n.btn__upload {\n  display: flex;\n  align-items: center;\n  height: 2em;\n  // padding: 0 5px;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  label {\n    display: flex;\n    align-items: center;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 50%;\n  }\n\n  p {\n    display: inline;\n    font-style: italic;\n    font-weight: 400;\n  }\n}\n\n.remindBtn--blue {\n  svg g path {\n    stroke: #426ba6;\n    stroke-opacity: 0.7;\n  }\n}\n\n.remindBtn--green {\n  svg g path {\n    stroke: #69a042;\n  }\n}\n.remindBtn--yellow {\n  svg g path {\n    stroke: #ffa31a;\n  }\n}\n.remindBtn--red {\n  svg g path {\n    stroke: #b72025;\n  }\n}\n.remindBtn--grey {\n  svg g path {\n    stroke: #c8c8c8;\n  }\n}\n.remindBtn--transparent {\n  svg g path {\n    stroke: transparent;\n  }\n}\n\n.close_btn {\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: 1px solid #426ca65e;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  background-color: aliceblue;\n  font-size: 20px;\n  line-height: 19px;\n  font-weight: 300;\n  margin-top: -5px;\n  cursor: pointer;\n}\n\n.img_btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  img {\n    width: 1em;\n    height: 1em;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n  .img_disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n  &.definedFilters {\n    background-color: #dae1ec;\n    border-radius: 50%;\n    width: 3em;\n    height: 3em;\n    // border-radius: $borderRadius;\n    // box-shadow: $filterBtnBoxShadow;\n    box-shadow: rgba(0, 0, 0, 0.2) 0 3px 5px -1px, rgba(0, 0, 0, 0.14) 0 6px 10px 0, rgba(0, 0, 0, 0.12) 0 1px 18px 0;\n  }\n  &.filterBtn {\n  }\n}\n.iconBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  opacity: 1;\n  transition: opacity 0.3s $iconHoverTransition;\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.filter-icon-btn {\n  background-color: transparent;\n  border-radius: 50%;\n  width: 3em;\n  height: 3em;\n  // border-radius: $borderRadius;\n  // box-shadow: $filterBtnBoxShadow;\n  box-shadow: transparent 0 3px 5px -1px, transparent 0 6px 10px 0, transparent 0 1px 18px 0;\n  transition: box-shadow 0.3s $iconHoverTransition, background-color 0.3s $iconHoverTransition;\n  &.definedFilters {\n    background-color: #dae1ec;\n    border-radius: 50%;\n    width: 3em;\n    height: 3em;\n    // border-radius: $borderRadius;\n    // box-shadow: $filterBtnBoxShadow;\n    box-shadow: rgba(0, 0, 0, 0.2) 0 3px 5px -1px, rgba(0, 0, 0, 0.14) 0 6px 10px 0, rgba(0, 0, 0, 0.12) 0 1px 18px 0;\n  }\n}\n\n.little-icon-btn {\n  width: 12px;\n  height: 12px;\n}\n\n.button-add-img {\n  position: absolute;\n  bottom: -25px;\n  right: -5px;\n  // @include mx.min-width(1440px) {\n  //   bottom: -22px;\n  // }\n}\n\n.iconBtn-border {\n  border: 2px solid $textColor;\n  border-radius: 50%;\n  transition: scale 0.3s $iconHoverTransition;\n  &:hover {\n    scale: 1.5;\n  }\n  &:disabled {\n    scale: 1;\n  }\n}\n\n.link-iconBtn {\n  background-color: $borderColorLight;\n  border-radius: 4px;\n  width: 66px;\n  height: 28px;\n  box-shadow: $btnBoxShadow;\n  transition: box-shadow $commonTransition;\n  &:not(:disabled):hover {\n    box-shadow: $btnHoverBoxShadow;\n  }\n}\n.activeBtn {\n  background-color: $activeBtnColor;\n  border-radius: 4px;\n  width: 40px;\n}\n\n.widthBtn {\n  width: 40px;\n}\n\n.external-iconBtn {\n  background-color: $borderColorLight;\n  border-radius: 4px;\n  width: 40px;\n\n  box-shadow: $btnBoxShadow;\n  transition: box-shadow $commonTransition;\n  &:not(:disabled):hover {\n    box-shadow: $btnHoverBoxShadow;\n  }\n}\n\n.shareBtn {\n  position: absolute;\n  bottom: 14px;\n  right: 5.5%;\n  z-index: 500;\n}\n\n.button-del-img {\n  position: absolute;\n  right: -3px;\n  top: -3px;\n}\n.button-main-del-img {\n  position: absolute;\n  right: -3px;\n  top: -3px;\n\n  @include mx.min-width(1600px) {\n    right: 15px;\n  }\n}\n.logoutBtn {\n  width: 14px;\n  height: 14px;\n}\n\n.filter_btn {\n  background: transparent;\n  border: 0;\n\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  border: 1px solid #426ca65e;\n\n  white-space: nowrap;\n  width: 100%;\n  font-size: \"0.8em\";\n  // background:#DAE1EC\n}\n\n.left_fixed_btn {\n  position: absolute;\n  left: 1em;\n  bottom: 1em;\n}\n.right_fixed_btn {\n  position: absolute;\n  right: 1em;\n  bottom: 1em;\n}\n\n.reestr_btn {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  .label {\n    white-space: nowrap;\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 50%;\n  }\n}\n\n.status-button_info {\n  padding: 2px 1.5em;\n  border-radius: 3px;\n  border: 0.5px solid var(--main-80, #88a5cf);\n  background: var(--main-20, #dae1ec);\n\n  img {\n    width: 2em;\n  }\n}\n\n.status-button {\n  width: 80px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  background-color: #dae1ec;\n  border-radius: 7%;\n  cursor: pointer;\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.6;\n  }\n}\n\n.status-circle-external {\n  box-sizing: content-box;\n  border-radius: 50%;\n  border: 1px solid grey;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.status-circle-internal {\n  border-radius: 50%;\n  width: 14px;\n  height: 14px;\n}\n\n.pressed {\n  background-color: #7b828c8a;\n  box-shadow: rgba(0, 0, 0, 0.2) 0 -3px -5px 1px, rgba(0, 0, 0, 0.14) 0 -6px -10px 0, rgba(0, 0, 0, 0.12) 0 -1px -18px 0;\n  border-radius: 5px;\n}\n\n.active-action-button {\n  background: rgba(218, 225, 236, 1);\n}\n\n.btn-responsive {\n  transition: box-shadow 0.3s $transitionFunc, transform 0.3s $transitionFunc;\n\n  &:hover {\n    box-shadow: $btnHoverBoxShadow;\n  }\n\n  &:active {\n    transform: scale(0.97);\n    box-shadow: $btnBoxShadow;\n  }\n}\n\n.reversIconBtn {\n  transform: rotate(180deg);\n}\n\n.btnSign {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  width: 18px;\n  height: 18px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 10px;\n  font-weight: bold;\n  color: #ffffff;\n  border-radius: 50%;\n  background-color: $accentColor;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n","$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$borderColorLight: #dae1ec;\n$accentFilterColor: #ff8040;\n$accentColor: #b72025;\n$warningColor: #d3c71c;\n$succesColor: #00dbbb;\n$accentTableRowColor: #ecc0c1;\n$filtersBgColor: #d6dfea71; //#d6dfea\n$filterTitleColor: #d6dfea93;\n$textColor: #426ba6;\n$filtersBorderColor: #426ba6;\n$deletedTextColor: #b72025;\n$iconFill: #829ec4;\n$logoIcon: #6d91c6;\n$activeBtnColor: rgba(218, 225, 236, 1);\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n$btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;\n$reactTableShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;\n$dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;\n$commonShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$commonShadowHover: rgba(67, 71, 85, 0.27) 1px 1px 0.25em, rgba(90, 125, 188, 0.05) 1px 0.3em 1em;\n\n$transition: ease;\n$transitionFunc: cubic-bezier(0.25, 1, 0.5, 1);\n$iconHoverTransition: cubic-bezier(0.22, 1, 0.36, 1);\n$commonTransition: 0.3s $transitionFunc;\n\n:root {\n  --filterBtnBoxShadow: #{$filterBtnBoxShadow};\n  --btnBoxShadow: #{$btnBoxShadow};\n  --btnHoverBoxShadow: #{$btnHoverBoxShadow};\n  --dividerShadow: #{$dividerShadow};\n}\n\n$main-font: \"Roboto\", sans-serif;\n\n$font-weights: (\n  \"Light\": 300,\n  \"Regular\": 400,\n  \"Medium\": 500,\n  \"Bold\": 700,\n);\n","//flex\n@mixin flex($gap: 0) {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: $gap;\n}\n\n@mixin flexCenter($gap: 0) {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: $gap;\n}\n\n@mixin flexStart {\n  display: flex;\n  justify-content: flex-start;\n  align-items: baseline;\n}\n\n@mixin flexSpB {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n@mixin flexBslnSpcBtwn {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n}\n\n@mixin flexColumn($gap: 0) {\n  display: flex;\n  flex-direction: column;\n  gap: $gap;\n}\n\n@mixin twoColumnsMain {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 5px;\n\n  & > :first-child,\n  & > :last-child {\n    flex-shrink: 0;\n  }\n\n  & > :first-child {\n    width: 51%;\n    padding-right: 7px;\n    @include borderR;\n  }\n\n  & > :last-child {\n    width: 50%;\n    padding-left: 7px;\n  }\n}\n\n@mixin twoColumnsRow($first: 50%, $second: 50%) {\n  display: flex;\n  justify-content: space-between;\n\n  & > :first-child,\n  & > :last-child {\n    flex-shrink: 0;\n  }\n\n  & > :first-child {\n    width: $first;\n  }\n\n  & > :last-child {\n    width: $second;\n  }\n}\n\n@mixin treeColumnsRow($first: 33%, $second: 33%, $third: 33%) {\n  display: flex;\n  justify-content: space-between;\n\n  & > :first-child,\n  & > :nth-child(2),\n  & > :last-child {\n    flex-shrink: 0;\n  }\n\n  & > :first-child {\n    width: $first;\n  }\n\n  & > :nth-child(2) {\n    width: $second;\n  }\n\n  & > :last-child {\n    width: $third;\n  }\n}\n\n//general\n@mixin centerElement {\n  margin-left: 50%;\n  position: relative;\n  transform: translate(-50%, 0);\n}\n\n@mixin border {\n  border: 1px solid $borderColor;\n}\n\n@mixin borderT {\n  border-top: 1px solid $borderColor;\n}\n\n@mixin borderL {\n  border-left: 1px solid $borderColor;\n}\n\n@mixin borderR {\n  border-right: 1px solid $borderColor;\n}\n\n@mixin borderB {\n  border-bottom: 1px solid $borderColor;\n}\n\n@mixin middleBottom {\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: auto;\n}\n\n@mixin sectionHeader {\n  font-family: Roboto;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n@mixin centerH {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n//clean styles\n@mixin cleanButton {\n  border: 0;\n  margin: 0;\n  padding: 0;\n  display: block;\n  color: inherit;\n}\n\n@mixin cleanList {\n  list-style: none;\n  padding-left: 0;\n}\n\n@mixin cleanHeader {\n  color: inherit;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-weight: inherit;\n  font-size: inherit;\n}\n\n@mixin min-width($width) {\n  @media (min-width: $width) {\n    @content;\n  }\n}\n@mixin max-width($width) {\n  @media (max-width: $width) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
